// src/components/Layout/AppLayout.tsx
import React, { useState } from 'react';
import { Layout, Menu, Popover } from 'antd';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { DashboardOutlined, UserOutlined } from '@ant-design/icons';
import ProfileHeader from './ProfileHeader';

const { Sider } = Layout;

interface AppLayoutProps {
  onLogout: () => void;
}

const AppLayout: React.FC<AppLayoutProps> = ({ onLogout }) => {
  const [collapsed, setCollapsed] = useState(true);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const location = useLocation();

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* Sidebar */}
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <Menu
          style={{ marginTop: 20 }}
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={[
            {
              key: '/dashboard',
              icon: <DashboardOutlined />,
              label: <Link to="/dashboard">Dashboard</Link>,
            },
          ]}
        />

        {/* Bottom Profile */}
        <div
          style={{
            position: 'absolute',
            bottom: 20,
            padding: 16,
            width: '100%',
          }}>
          <Popover
            align={{
              offset: [25, -10], // [horizontal, vertical] - moves content 10px to the right
            }}
            arrow={false}
            trigger="click"
            open={isProfileOpen}
            onOpenChange={setIsProfileOpen}
            placement="right"
            content={<ProfileHeader onLogout={onLogout} onClose={() => setIsProfileOpen(false)} />}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: collapsed ? 0 : 10,
                color: '#fff',
                cursor: 'pointer',
                padding: '12px 16px',
              }}>
              <UserOutlined />
              {!collapsed && <span>Profile</span>}
            </div>
          </Popover>
        </div>
      </Sider>

      {/* Main Content */}
      <Layout>
        <Outlet context={{ collapsed, setCollapsed }} />
      </Layout>
    </Layout>
  );
};

export default AppLayout;
